import $ from 'jquery';
import animateDivs from './so-animate';

// if ( $('.video-slideshow-block').length ) {
//   $('.close-popup').on('click', function() {
//     $('.so-popup').removeClass('active video-popup')
//   })
//   $('.video-slideshow-block .slideshow-nav .slideshow-image-wrapper').on('click', function () {
//     const videoId = $(this).data('video-id')
//     const slide = $(this)
//     const ifrm = document.createElement('iframe');
//         ifrm.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`);
//         ifrm.setAttribute('frameborder', '0')
//         ifrm.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture')
//         ifrm.setAttribute('allowfullscreen', true)
//     const slideParent = slide.closest('.video-slideshow-block')
//
//     console.log(slideParent)
//     $('.slideshow-images .slideshow-image', slideParent).html(ifrm)
//   })
// }

if ( $('.video-preview').length ) {
  $('.video-preview').on('click', function() {
    const videoId = $(this).data('video-id')
    const ifrm = document.createElement('iframe');
          ifrm.className = 'absolutify'
          ifrm.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&enablejsapi=1`);
          ifrm.setAttribute('frameborder', '0')
          ifrm.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture')
          ifrm.setAttribute('allowfullscreen', true)
    const videoWrapper = document.createElement('div')
          videoWrapper.className = 'bg-image-container'
    const videoContainer = document.createElement('div')
          videoContainer.className = 'bg-image'
          videoContainer.appendChild(ifrm)
          videoWrapper.appendChild(videoContainer)
    $('.so-popup').addClass('active video-popup')
    $('.so-popup-content').html(videoWrapper)

    $('.so-popup').off('click').on('click', function(e) {
      if ( e.target != $('.so-popup-content')) {
        $('.so-popup').removeClass('active video-popup')
        $('.so-popup-content').empty()
      }
    })
  })
}

if ( $('.playlist-feed-header').length ) {
  let currentPage = 1
  $('.playlist-feed-header button').on('click', function(e) {
    e.preventDefault()
    currentPage = 1
    $('.playlist-feed-header button').removeClass('active')
    $(this).addClass('active')
    get_more_so_videos();
  })

  $('.video-page-content .more-posts').on('click', function(e) {
    currentPage++
    get_more_so_videos();
  })

  function get_more_so_videos () {
    $('.more-posts').html('loading')
    const ajaxData = {
      'action': 'do_ajax',
      'fn' : 'get_more_videos'
    }
    if ( $('.playlist-feed-header button.active').length ) {
      const playlist = $('.playlist-feed-header button.active').data('playlist-id')
      ajaxData.playlist = playlist;
    }
    if ( currentPage > 1 ) {
      ajaxData.nextVideos = $('.playlist-feed-container .more-posts').data('next-videos')
    }
    $.ajax({
      url: ajaxurl,
      method: 'post',
      type: 'json',
      data: ajaxData
    }).done(function (response) {
      if ( currentPage === 1 ) {
        $('.playlist-feed').empty()
      }
      if ( response ) {
        const data = JSON.parse(response)
        $('.playlist-feed').append(data.videos)
        if (!data.more_videos) {
          $('.more-posts').hide();
        } else {
          $('.more-posts').show().html('more videos');
        }
        $('.video-preview').each( function (i) {
          const indexes = [0,1,2]
          console.log($.inArray( i, indexes ))
          const currentVid = $(this);
          if ( $.inArray( i, indexes ) > -1 ) {
            currentVid.addClass('animated')
          }
        })
        animateDivs()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./js/so-video-scripts.js